export const TOAST_OPTIONS = {
  duration: 5000,
  style: {
    background: '#363636',
    color: '#fff',
  },
  success: {
    duration: 3000,
    theme: {
      primary: 'green',
      secondary: 'black',
    },
  },
  zIndex: 9999,
}

export const TOAST_POSITION = 'top-right'
export const TOAST_REVERSE_ORDER = false
